<template>
  <div class="list-project-container" style="width: 100%"
       element-loading-text="Идет первичная настройка демо проекта, это занимает некоторое время, пожалуйста подождите..."
       v-loading="loaderCreate">
    <div class="projects-list" v-loading="loading">
      <el-alert
        v-if="!loading && !projects.length"
        title="У вас нет ниодного проекта"
        type="warning"
        description="Пожалуйста, создайте проект,
      или присоеденитесь к уже созданому, чтоб приступить к работе"
        show-icon
      >
      </el-alert>
      <h4>Выберите проект</h4>
      <el-input c placeholder="Поиск ..." v-model="search" class="input-search" v-if="projects.length > 3">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="projects-ul">
        <div
          @click="setProjectId(project)"
          :class="['projects-li', {
            active: $store.state.project.id === project.id &&
            $route.name !== 'usersProject',
            disabled: project.disabled,
            is_demo: project.isDemo
          }]"
          v-for="(project, index) in filteredList"
          :key="index"
        >
          <span>{{ project.name }}</span>
          <i class="fas fa-chevron-right"></i>
        </div>
        <div @click="projectBlockAlert">
          <AddProject
            :class="{
            disabled: false,
            pointer_events: false ,
          }"
            v-if="$route.name !== 'usersProject'" @new-project="addNewProject"
          />
        </div>

        <el-dialog
          title="Наши контакты"
          :visible.sync="contactDialog"
          width="30%"
        >
          <div>
          <span>
            Для активации подписки пожалуйста свяжитесь с нами по email:
            <strong>info@stroybots.ru</strong> или телефону <strong>+7(919) 458-60-81</strong>
          </span>
          </div>
          <span slot="footer" class="dialog-footer">
          <el-button @click="contactDialog = false">Закрыть</el-button>
        </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import AddProject from '@/views/Dashboard/Projects/components/AddProject';
import firebase from 'firebase';
import dayjs from 'dayjs';
import {getSchema} from "../../../firestore/demo";

export default {
  name: 'List',
  components: {AddProject},
  data() {
    return {
      search: '',
      loaderCreate: false,
      loading: false,
      projects: [],
      isDisabled: false,
      contactDialog: false,
      contacts: {
        name: '',
        email: '',
        phone: '',
        company: '',
      },
    };
  },

  mounted() {
    this.loading = true;

    let usersStat = null;

    firebase.firestore().collection('userStat')
      .where(`uid`, '==', firebase.auth().currentUser.uid).get().then(async (data) => {
      data.forEach((sub) => {
        usersStat = sub.data();
      });
    })

    firebase
      .firestore()
      .collection('superuser')
      .where('user', '==', firebase.auth().currentUser.uid)
      .get()
      .then(async (data) => {
        if (data.size) {
          this.getDemo();
        }
      });


    firebase.firestore().collection('projects')
      .where(`rules.${firebase.auth().currentUser.uid}`, '>', '')
      .get().then(async (r) => {
        console.log(r)
      const projects = [];
        console.log(r, 'R')
      await r.forEach((subDoc) => {

        // if (usersStat && usersStat.end_date) {
        //   disabled = usersStat.end_date ? usersStat.end_date < dayjs().utc().unix() : false
        // } else {
        let disabled = subDoc.data().end_date ? subDoc.data().end_date < dayjs().utc().unix() : false
        // }


        projects.push({
          id: subDoc.id,
          ...subDoc.data(),
          disabled,
        });
      });
      const projectLength = projects.filter((p) => p.owner === firebase.auth().currentUser.uid && p.end_date).length;
      if (usersStat && usersStat.end_date) {
        const end_date = String(usersStat.end_date).length < 13 ? usersStat.end_date * 1000 : usersStat.end_date;
        this.isDisabled = end_date < dayjs().utc().unix()
      } else {
        this.isDisabled = (projects.filter((p) => p.disabled && p.owner === firebase.auth().currentUser.uid).length === projectLength);
        if (this.isDisabled && usersStat && usersStat.createDate) {
          const endDate = dayjs(String(usersStat.createDate).length < 13 ? usersStat.createDate * 1000 : usersStat.createDate)
            .add(1, 'months').unix()
          this.isDisabled = endDate < dayjs().utc().unix()
        }
      }
      this.projects = projects;

      this.projects.forEach((dd) => {
        console.log(dd.name, dd.id)
      })
      this.loading = false;
    }).catch((error) => {
      this.loading = false;
    });
  },

  methods: {
    async createDemoProject() {
      this.loaderCreate = true
      const project = await getSchema()
      this.setProjectId(project)
      // this.loaderCreate = false
    },
    submitContact() {
      firebase.firestore()
        .collection('contacts')
        .add({
          uid: firebase.auth().currentUser.uid,
          ...this.contacts,
        }).then(() => {
        this.contactDialog = false;
      });
    },
    getDemo() {
      firebase.firestore().collection('projects')
        .where('isDemo', '==', true)
        .get().then(async (r) => {
        const projects = [];
        await r.forEach((subDoc) => {
          projects.push({
            id: subDoc.id,
            ...subDoc.data(),
          });
        });
        this.projects = [...projects, ...this.projects];
      });
    },
    addNewProject(project) {
      if (!this.projects.length) {
        this.setProjectId(project);
      } else {
        this.projects.push(project);
      }
    },
    projectBlockAlert() {
      // if (!this.isDisabled) {
      //   return
      // }
      // this.$confirm('Для продолжения работы в ваших проектах обновите подписку',
      //   'Ваша подписка больше не активна', {
      //     confirmButtonText: 'Контакты',
      //     cancelButtonText: 'OK',
      //   }).then(() => {
      //   this.contactDialog = true;
      // });
    },
    checkDisabled(project) {
      if (project.disabled && project.owner === firebase.auth().currentUser.uid) {
        this.projectBlockAlert();
        return false;
      }
      return true;
    },
    setProjectId(project) {
      if (!this.checkDisabled(project)) {
        this.projectBlockAlert();
        return;
      }

      if (project.disabled) {
        return;
      }

      if (this.$route.name !== 'usersProject') {
        localStorage.setItem('projectId', project.id);

        if (this.$store.state.project.id && this.projects.length) {
          this.$store.dispatch('resetProject', project);
          this.$router.push('/dashboard');
        } else {
          window.location.reload();
        }
      } else {
        this.$router.push(`/dashboard/users/project/${project.id}`);
      }
    },
  },

  computed: {
    filteredList() {
      return this.projects.filter(job => {
        if (job.isDelete) {
          return false
        }
        if (job.name) {
          return job.name.toLowerCase().includes(this.search.toLowerCase());
        }
        return false
      });
    },
  },
};
</script>

<style lang="scss">
.projects-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.projects-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .projects-li, > > > .projects-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;


    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.is_demo {
  background: #eaffe0;
}

.disabled {
  opacity: 0.6;
}

.pointer_events {
  pointer-events: none !important;
}


</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/List.vue